// extracted by mini-css-extract-plugin
export default {"modal":"SubscribeFormModel_modal__J+LKV"};